// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-alert[data-v-b583ded2] {\n  color: white;\n}[dir] .bg-alert[data-v-b583ded2] {\n  background: #671e85;\n  border-radius: 5px;\n}\n.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th[data-v-b583ded2] {\n  color: white !important;\n}\n[dir] .vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th[data-v-b583ded2] {\n  padding: 10px 15px;\n  background: rgba(var(--vs-primary), 1) !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
